<template>
    <div class="container">
        <div class="row">
            <div class="col s12" style="display:flex;align-items: center;">
                <div class="input-field inline">
                    <i class="material-icons prefix">search</i>
                    <input id="email_inline" type="email" class="validate"
                        @input="search = $event.target.value">
                    <label for="email_inline">Search</label>
                </div>
                <a class="btn" style="margin-left:5px;" @click="$emit('newpost')">
                    <i class="material-icons">add</i>
                    <span style="transform:translate(0px, -4px);padding-left:5px;display:inline-block;">New Post</span>
                </a>
            </div>
        </div>
        <div v-html="notehtml"></div>
    </div> 
</template>

<script>
export default {
    name: '',
    props: {
        notelist: {
            type: Array,
            default: () => []
        }
    },
    components: {

    },
    computed: {
        notehtml(){
            if (!this.notelist) return
            let s = this.search.toLowerCase()
            let notelist = []
            console.log(this.notelist)
            if (s == '')
                notelist = [...this.notelist]
            else
                notelist = this.notelist.filter(d => d.title.includes(s))
            console.log('notelist', notelist)
            const notestruct = notelist.reduce((g,c,i) => {
                console.log(c)
                let c2 = c.title.split('/')
                let gtemp = g
                for (let idx in c2){
                    let c3 = c2[idx]
                    let found = false
                    for (let node of gtemp.children){
                        if (node.name == c3){
                            found = true
                            gtemp = node
                            break
                        }
                    }
                    if (!found){
                        let link = {}
                        if (idx == c2.length-1)
                            link = {link: c}
                        let aux = {
                            name: c3,
                            label: c2[idx],
                            children: [],
                            ...link,
                            key: c.key
                        }
                        gtemp.children.push(aux)
                        gtemp = aux
                    }
                }
                return g
            }, {name: '___root', children: []})
            let html = '<ul>'
            const looper = (node, path='') => {
                if (node.name == '___root'){
                    for (let c of node.children){
                        html += '<ul>'
                        looper(c, path)
                        html += '</ul>'
                    }
                }else{
                    html += `<li onmousemove="event.stopPropagation(); event.target.querySelector('img') ? event.target.querySelector('img').style.opacity=100 : ''" 
                                onmouseout="event.stopPropagation(); event.target.querySelector('img') ? event.target.querySelector('img').style.opacity=0 : ''"/>`
                    if (node.link)
                        html += `<a href="#!" onclick="window.notesClick('${btoa(JSON.stringify(node))}')">${node.label}</a>`
                    else
                        html += node.label
                    let path2 = path + '/' + node.label
                    html += ` <img 
                                onmousemove="event.stopPropagation(); event.target.style.opacity=100" 
                                onmouseout="event.stopPropagation(); event.target.style.opacity=0"
                    class="imghover" style="cursor:pointer;opacity:0;width:14px;" 
                    src="/assets/icons/plus.png" onclick="window.newPost('${path2.slice(1,path2.length)}/')"/>`
                    for (let c of node.children){
                        html += '<ul>'
                        looper(c, path+'/'+node.label)
                        html += '</ul>'
                    }
                    html += '</li>'
                }
            }
            looper(notestruct)
            html += '</ul>'
            return html
        }

    },
    props: {
        notelist: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            search: '',
        }
    },
    mounted(){

    },
    methods: {

    },
}
</script>

<style>
</style>